import styled, { css } from 'styled-components';
import { rgba } from 'polished';

import { c333353 } from '#/colors';

export const verticalSpacerCss = css`
  background-image: linear-gradient(
    to bottom,
    ${rgba(c333353, 0)},
    ${c333353},
    ${rgba(c333353, 0)}
  );
  height: 100%;
  width: 1px;
`;

export const VerticalSpacer = styled.div`
  ${verticalSpacerCss}
`;

export const horizontalSpacerCss = css`
  background-image: linear-gradient(
    to left,
    ${rgba(c333353, 0)},
    ${c333353},
    ${rgba(c333353, 0)}
  );
  height: 1px;
  width: 100%;
`;

export const HorizontalSpacer = styled.div`
  ${horizontalSpacerCss}
`;
